
import React from 'react';
import { AlertCircle } from 'lucide-react';
import { Link } from 'react-router-dom';

interface ErrorStateProps {
  errorMessage?: string;
}

const ErrorState: React.FC<ErrorStateProps> = ({ 
  errorMessage = "We couldn't find this download. It may have been removed or the URL is incorrect."
}) => {
  return (
    <div className="max-w-xl mx-auto flex items-center justify-center min-h-[300px]">
      <div className="text-center">
        <AlertCircle className="h-8 w-8 text-destructive mx-auto mb-4" />
        <h2 className="text-xl font-medium mb-2">Download Not Found</h2>
        <p className="text-muted-foreground mb-4">
          {errorMessage}
        </p>
        <Link 
          to="/tracks" 
          className="text-primary hover:underline"
        >
          Return to your tracks
        </Link>
      </div>
    </div>
  );
};

export default ErrorState;
